export default function(x, y) {
  if ('scrollBehavior' in document.documentElement.style) {
    window.scroll({
      top: y,
      left: x,
      behavior: 'smooth'
    });
  }
  else {
    window.scrollTo(x, y);
  }
}
